import Vue from "vue";
import Router from "vue-router";
import login from "@/view/login/login";
import master from "@/view/master/master";
import home from "@/view/home/home";
import userManagement from "@/view/userManagement/userManagement";
import accountManagement from "@/view/accountManagement/accountManagement";
import MembershipSettings from "@/view/MembershipSettings/MembershipSettings";
// 
// 
import orderManagement from "@/view/orderManagement/orderManagement";
import projectManagement from "@/view/projectManagement/projectManagement";
import PersonnelManagement from "@/view/PersonnelManagement/PersonnelManagement";
import ProjectInformation from "@/view/ProjectInformation/ProjectInformation";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "login",
      component: login,
      meta: {
        title: "杰诚工控后台管理系统"
      }
    },
    {
      path: "/master",
      name: "master",
      component: master,
      children: [
        {
          path: "/home",
          name: "home",
          component: home,
          meta: {
            title: "首页"
          }
        },
        {
          path: "/userManagement",
          name: "userManagement",
          component: userManagement,
          meta: {
            title: "用户管理列表"
          }
        },
        {
          path: "/accountManagement",
          name: "accountManagement",
          component: accountManagement,
          meta: {
            title: "账号管理"
          }
        },
        {
          path: "/MembershipSettings",
          name: "MembershipSettings",
          component: MembershipSettings,
          meta: {
            title: "客户管理"
          }
        },
        {
          path: "/orderManagement",
          name: "orderManagement",
          component: orderManagement,
          meta: {
            title: "订单管理"
          }
        },
        {
          path: "/projectManagement",
          name: "projectManagement",
          component: projectManagement,
          meta: {
            title: "项目管理"
          }
        },
        {
          path: "/PersonnelManagement",
          name: "PersonnelManagement",
          component: PersonnelManagement,
          meta: {
            title: "人员管理"
          },
          children: [
          ]
        },
        {
          path: "/ProjectInformation",
          name: "ProjectInformation",
          component: ProjectInformation,
          meta: {
            title: "项目详情"
          }
        }

      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js